import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthRequired = ({ user, children }) => {
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthRequired;
